import { BaseMapper } from '@ps/utils';

import { InvoiceCompanyItemDto } from '../dtos/invoice-company.dto';
import { InvoiceCompany } from '../../models/invoice-company.model';

export class InvoiceCompanyMapper extends BaseMapper<
  InvoiceCompanyItemDto,
  InvoiceCompany
> {
  public fromDto(dto: InvoiceCompanyItemDto): InvoiceCompany {
    return {
      id: dto.id,
      name: dto.name,
      isABuyer: dto.isABuyer ?? false,
      generateInvoice: dto.generateInvoice ?? null,
      invoiceTypeHistory:
        dto.invoiceTypeHistory?.map((entry) => ({
          period: entry.period,
          invoiceType: entry.invoiceType,
        })) ?? null,
    };
  }
}
